import React, { Fragment, useEffect, useState } from "react";

import { Col, Row } from "antd";

import Container from "@/components/container/Container";
import ButtonComponent from "@/components/button/Button";

import "@/styles/layout/footer.scss";
import FooterTopbar from "@/components/footer-topbar";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const data = searchParams.get("data");

  const [isDataParams, setIsDataParams] = useState(false);
  useEffect(() => {
    // console.log(data);
    if (data) {
      setIsDataParams(true);
    }
  }, [data]);

  if (isDataParams) return null;

  return (
    <Fragment>
      <FooterTopbar />
      <div className="footer">
        <Container>
          <Row>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
              <div className="copy-rights body-b4">© 2024 Inforens. All rights reserved.</div>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
              <div className="policy-term">
                <ButtonComponent
                  className="policy body-b4"
                  label="Privacy Policy & Credits"
                  varient="link"
                  onClick={() => navigate("/privacy-policy")}
                />
                <ButtonComponent
                  className="term body-b4"
                  label="Terms & Conditions"
                  varient="link"
                  onClick={() => navigate("/terms-and-condition")}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
};

export default Footer;
